<template>
  <div class="multiple-body">
    <div class="multiple-main">
      <div class="left-input" @click.stop="showModal()">
        <span v-if="!chooseList.length" style="padding-left: 0.1rem">{{ placeholder }}</span>
        <span v-else v-for="item of chooseList" :key="item.id" class="title">
          {{ item.name }}
        </span>
      </div>
      <!-- <img src="/img/ui/law/add.png"> -->
    </div>
    <div class="org-modal-main" @click.stop="close" v-if="show">
      <div class="org-modal-contaier" @click.stop="">
        <div class="org-header">
          <span>{{ placeholder }}</span>
          <img src="/img/ui/law/close.png" @click.stop="close()">
        </div>
        <div class="org-content">
          <tree :treeData="treeData" :chooseList="chooseList"></tree>
        </div>
        <div class="org-footer">
          <button class="primary" @click.stop="submit()">确定</button>
          <button @click.stop="close">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tree from './tree'
import { listToTree } from '@/plugins'

export default {
  components: {
    tree
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    arrayData: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data () {
    return {
      show: false,
      chooseList: [],
      isTree: true,
      treeArray: []
    }
  },
  computed: {
    treeData () {
      return this.treeArray
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (val) {
        if (!val) {
          this.chooseList = []
          this.treeArray = listToTree(
            this.arrayData.map(item => {
              item.checked = false
              return item
            })
          )
        } else {
          let list = val.split(',') || []
          this.arrayData.forEach(item => {
            if (list.includes(item.id)) {
              item.checked = true
            } else {
              item.checked = false
            }
          })
        }
      }
    },
    arrayData: {
      immediate: true,
      handler (val) {
        this.treeArray = listToTree(val)
      }
    }
  },
  mounted () {
    this.$on('choose-node', this.chooseNode)
    this.$on('delete-node', this.deleteNode)
  },
  beforeDestroy () {
    this.$off('choose-node')
    this.$off('delete-node')
  },
  methods: {
    chooseNode (node) {
      this.chooseList.push(node)
    },
    beingArray (opt) {
      return this.chooseList.find(item => item.id === opt.id)
    },
    deleteNode (node) {
      if (this.beingArray(node)) {
        this.chooseList = this.chooseList.filter(item => item.id !== node.id)
      }
    },
    close () {
      this.treeArray = listToTree(
        this.arrayData.map(item => {
          item.checked = false
          return item
        })
      )
      this.chooseList = []
      this.$emit('input', '')
      this.show = false
    },
    showModal () {
      this.show = true
    },
    submit () {
      if (!this.chooseList.length) {
        this.close()
        this.$emit('input', '')
        return
      }
      let list = []
      this.chooseList.forEach(item => {
        list.push(item.id)
      })
      this.$emit('input', list.join(','))
      this.show = false
    }
  }
}
</script>
<style lang="stylus" scoped>
.multiple-body
  color #333
  width 100%
  .multiple-main
    position relative
    margin 0.1rem 0
    &:first-child
      margin-top 0
    .left-input
      min-height 0.7rem
      font-size 0.22rem
      border-radius 0.06rem
      padding 0 0.1rem
      background rgba(255, 255, 255, 0.2)
      color #fff
      width 100%
      display flex
      align-items center
      flex-wrap wrap
      .title
        margin-right 0.2rem
        &:first-child
          margin-left 0
    img
      width 0.4rem
      height 0.4rem
      position absolute
      right 0
      top 0.15rem
.org-modal-main
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  background rgba(0, 0, 0, 0.5)
  height 100vh
  overflow auto
  display flex
  justify-content center
  align-items center
  z-index 1000
  .org-modal-contaier
    background #fff
    border-radius 0.1rem
    padding 0.24rem
    display flex
    flex-direction column
    width 80vw
    overflow hidden
    .org-header
      flex-shrink 0
      font-size 0.24rem
      position relative
      img
        width 24px
        height 24px
        position absolute
        top 0
        right 0
    .org-content
      flex auto
    .org-footer
      flex-shrink 0
      display flex
      align-items center
      padding 0.2rem 0
      button
        border-radius 4px
        width 2rem
        background #fff
        border 1px solid #dcdfe6
        color #333
        &:last-child
          margin-left 0.2rem
      .primary
        background #409eff
        color #fff
</style>
